import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.projects',
		defaultMessage: 'Projects',
		description: 'The link label for Projects',
	},
	labelGalaxia: {
		id: 'navigation.global-shortcuts.apps.projects-galaxia',
		defaultMessage: 'Spaces',
		description: 'The link label for Projects',
	},
});
